import config from "../../config/environment";
// import {
//   VfPagesUserData,
//   VfPagesProjectsData,
//   VfPagesWebsites,
// } from "../../interfaces/vfPages";
import { decodeTokenService } from "../decodeTokenService";
interface VfPagesAccessUrlWebsite {
  token: string;
  accessUrl: string;
  createdAt: number;
  expiresAt: number;
}

export class VPagesUsersService {
  private apiUrl = config.apiUrlWebsite;

  private getHeaders(isAuthRequired = true) {
    const headers: { [key: string]: string } = {
      "Content-Type": "application/json",
    };

    if (isAuthRequired) {
      const token = decodeTokenService.getToken();
      if (token) {
        headers["Authorization"] = `Bearer ${token}`;
      }
    }

    return headers;
  }

  // async getUserIdByEmail(email: string) {
  //   const response = await fetch(
  //     `${this.apiUrl}/vf-pages-users/find-user-by-email`,
  //     {
  //       method: "POST",
  //       headers: this.getHeaders(true), // Usar getHeaders con autenticación
  //       body: JSON.stringify({ email }),
  //     }
  //   );
  //   const userData: VfPagesUserData = await response.json();
  //   const userId = userData.data.id;
  //   return userId.toString();
  // }

  // async getProjectsByUserId(userId: string) {
  //   const response = await fetch(
  //     `${this.apiUrl}/vpages-projects/user/${userId}`,
  //     {
  //       headers: this.getHeaders(true), // Usar getHeaders con autenticación
  //     }
  //   );
  //   const projectsData: VfPagesProjectsData = await response.json();
  //   const projectId = projectsData.data[0].id;
  //   return projectId.toString();
  // }

  // async getWebsitesByProjectId(projectId: string) {
  //   const response = await fetch(
  //     `${this.apiUrl}/vpages-websites/${projectId}`,
  //     {
  //       headers: this.getHeaders(true), // Usar getHeaders con autenticación
  //     }
  //   );
  //   const websitesData: VfPagesWebsites = await response.json();
  //   return websitesData.data;
  // }

  // async getWebsitesSubdomainsByProjectId(projectId: string) {
  //   const response = await fetch(
  //     `${this.apiUrl}/api/VfPages/GetWebSitesByProjectId/${projectId}`,
  //     {
  //       headers: this.getHeaders(true), // Usar getHeaders sin autenticación (si es necesario)
  //     }
  //   );
  //   const websitesData: VfPagesWebsites = await response.json();
  //   return websitesData;
  // }

  // async getSsoUrl(userId: string, projectId: string, websiteId: string) {
  //   try {
  //     const response = await fetch(`${this.apiUrl}/fluxi-pages-auth`, {
  //       method: "POST",
  //       headers: this.getHeaders(true), // Usar getHeaders con autenticación
  //       body: JSON.stringify({ userId, projectId, websiteId }),
  //     });
  //     const data: VfPagesAccessUrlWebsite = await response.json();
  //     return data.accessUrl;
  //   } catch (error) {
  //     console.error("Error getting chat URL:", error);
  //     throw error;
  //   }
  // }

  async deleteWebsite(userId: string, id: string) {
    const response = await fetch(
      `${this.apiUrl}/delete-websites/${userId}/${id}`,
      {
        method: "DELETE",
        headers: this.getHeaders(true),
      }
    );
    const data = await response.json();
    return data;
  }

  // async createWebsite(projectId: string) {
  //   try {
  //     const response = await fetch(`${this.apiUrl}/vpages-websites`, {
  //       method: "POST",
  //       headers: this.getHeaders(true), // Usar getHeaders con autenticación
  //       body: JSON.stringify({ projectId }),
  //     });
  //     const data = await response.json();
  //     return data.success;
  //   } catch (error) {
  //     console.error("Error creating website:", error);
  //     throw error;
  //   }
  // }
}

export const vPagesUsersService = new VPagesUsersService();
